import { combineReducers } from 'redux';
import userActivation from './userActivation';
import emiInfo from './emiInfo';
import howToBuy from './howToBuy';
import widgetHeaders from './headers';
import merchantData from './merchantData';
import metadata from './metadata';
import ntbFlow from './ntbFlow';

const widgetData = combineReducers({
  userActivation,
  emiInfo,
  howToBuy,
  widgetHeaders,
  merchantData,
  metadata,
  ntbFlow,
});

export default widgetData;



// WEBPACK FOOTER //
// ./reducer/widgetData/index.js